import React from 'react'
import PropTypes from 'prop-types'
import {Image} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * Renders the logo image from a CMS GDIImageBlock with responsive `<picture>` sources.
 * When no valid image data is available it renders the provided FallbackComponent.
 *
 * Note: link handling lives in the parent Header — this component is intentionally
 * image-only so it can be passed as the `icon` prop of an `IconButton`.
 */
const CmsHeaderLogo = ({logoImageBlock, FallbackComponent, fallbackProps}) => {
    if (!logoImageBlock) {
        return <FallbackComponent {...fallbackProps} />
    }

    const resolveUrl = (ref) => ref?.Url || ref?.Expanded?.Url || null
    const mobileUrl = resolveUrl(logoImageBlock.Image)
    if (!mobileUrl) {
        return <FallbackComponent {...fallbackProps} />
    }

    const tabletUrl = resolveUrl(logoImageBlock.ImageTablet) || mobileUrl
    const desktopUrl = resolveUrl(logoImageBlock.ImageDesktop) || tabletUrl

    const maxWidth = logoImageBlock.MaxWidth || undefined

    return (
        <picture>
            {desktopUrl !== tabletUrl && (
                <source media="(min-width: 1024px)" srcSet={desktopUrl} />
            )}
            {tabletUrl !== mobileUrl && (
                <source media="(min-width: 768px)" srcSet={tabletUrl} />
            )}
            <Image
                src={mobileUrl}
                alt={logoImageBlock.ImageAltText || ''}
                display="block"
                maxWidth={maxWidth}
            />
        </picture>
    )
}

CmsHeaderLogo.propTypes = {
    logoImageBlock: PropTypes.object,
    FallbackComponent: PropTypes.elementType.isRequired,
    fallbackProps: PropTypes.object
}

export default CmsHeaderLogo
